import {File, FileText, FileType, ImageIcon, Link, Sheet} from "lucide-react"
import {AttachmentType} from "@/pb/api/devplan/types/attachments"
import {IconJira, IconLinear} from "@/app/components/icons/Icons"

/**
 * Returns the appropriate icon component for an attachment type.
 */
export function getAttachmentIcon(type: AttachmentType, fileName: string | undefined) {
  if (type === AttachmentType.JIRA_ISSUE) {
    return <IconJira className="size-5"/>
  }
  if (type === AttachmentType.LINEAR_ISSUE || type === AttachmentType.LINEAR_PROJECT) {
    return <IconLinear className="size-5"/>
  }
  if (type === AttachmentType.IMAGE) {
    return <ImageIcon className="size-5 text-green-500"/>
  }
  if (type === AttachmentType.URL) {
    return <Link className="size-5 text-muted-foreground"/>
  }
  if (type === AttachmentType.SPREADSHEET) {
    return <Sheet className="size-5 text-emerald-600"/>
  }

  const ext = fileName?.split('.').pop()?.toLowerCase()

  if (ext === 'pdf') {
    return <FileText className="size-5 text-red-500"/>
  }
  if (ext === 'docx' || ext === 'doc') {
    return <FileType className="size-5 text-blue-500"/>
  }
  if (ext === 'md' || ext === 'markdown') {
    return <FileText className="size-5 text-gray-500"/>
  }
  if (ext === 'csv' || ext === 'xls' || ext === 'xlsx') {
    return <Sheet className="size-5 text-emerald-600"/>
  }

  if (type === AttachmentType.DOCUMENT) {
    return <FileText className="size-5 text-muted-foreground"/>
  }

  return <File className="size-5 text-muted-foreground"/>
}
